import React from "react";
import styled from "styled-components";
import "./index.scss";
import "@ey/motif-react-wrapper/ey-asu-motif.css";
import "@ey/styled-theme/styles.css";
import "./components/main.less";
import { useEffect, useState } from "react";
import Progress from "./components/Progress";
import Main from "./components/main/Main";
import { setLanguage } from "./util/utils";
import { UniversalService } from "./services/universal/UniversalService";
import EYLogoAndHelpUrl from "./components/EYLogoAndHelpUrl";
import TelemetryProvider from "./components/common/appinsight/TelemetryProvider";
import { getAppInsights } from "./components/common/appinsight/TelemetryService";
import "./index.scss";
import "@ey/motif-react-wrapper/ey-asu-motif.css";
import "@ey/styled-theme/styles.css";
import ProgressLoader from "./components/common/progressLoader";
import "./components/main.less";
import { parseErrorData } from "./helpers/common/DataUtilityHelper";
import { Environment } from "./util";

export interface AppProps {
  title: string;
  isOfficeInitialized: boolean;
}

const App: React.FC<AppProps> = ({ title, isOfficeInitialized }) => {
  const [userSettingLoaded, setUserSettingLoaded] = useState(false);
  const [userPreferenceErrorMessage, setUserPreferenceErrorMessage] = useState("");
  const [userDateTimeFormat, setUserDateTimeFormat] = useState(0);
  const [userLanguage, setUserLanguage] = useState("");

  useEffect(() => {
    loadUserSetting();
  }, []);

  const loadUserSetting = async () => {
    const userData = await UniversalService.getUserPreferenceAsync();

    if (userData && userData?.response && userData.response.data?.data) {
      const userPreferenceData = userData.response.data.data;
      if (userPreferenceData?.uidisplaylanguage_resourcename) {
        setUserLanguage(userPreferenceData.uidisplaylanguage_resourcename);
        setLanguage(userPreferenceData.uidisplaylanguage_resourcename);
      }
      if (userPreferenceData?.userdatetimeformat) {
        setUserDateTimeFormat(userPreferenceData.userdatetimeformat);
      }
      // Captured before Main renders, so it is available to derive the worksheet protection password.
      Environment.setCurrentUserGui(userPreferenceData?.gui);
    }
    const errorMessage = parseErrorData(userData);
    setUserPreferenceErrorMessage(errorMessage);
    setUserSettingLoaded(true);
  };

  const renderContent = () => {
    if (!isOfficeInitialized) {
      return (
        <Progress
          title={title}
          logo={require("../assets/logo-filled.png")}
          message="Please sideload your addin to see app body."
        />
      );
    }

    if (!userSettingLoaded) {
      return (
        <StyledAppSection className="main-wrap spinner-main">
          <section className="body-wrap">
            <section className="body-top-wrap">
              <EYLogoAndHelpUrl />
              <ProgressLoader show variant="default" />
            </section>
          </section>
        </StyledAppSection>
      );
    }

    const renderMainComponent = () => {
      return (
        <div id="mainto">
          {userSettingLoaded ? (
            <Main
              userPreferenceErrorMessage={userPreferenceErrorMessage}
              userDateTimeFormat={userDateTimeFormat}
              userLanguage={userLanguage}
            />
          ) : (
            <span></span>
          )}
        </div>
      );
    };

    const connectionString = Environment.getAppInsightsConfig().connectionString;

    return connectionString ? (
      <TelemetryProvider
        initialized={false}
        connectionString={connectionString}
        after={() => getAppInsights().trackPageView({ name: window.location.pathname })}
      >
        {renderMainComponent()}
      </TelemetryProvider>
    ) : (
      renderMainComponent()
    );
  };

  return renderContent();
};

export default App;

const StyledAppSection = styled.section`
  height: 100%;
  &.spinner-main {
    background-color: var(--neutrals-900);
  }
  .body-wrap {
    position: relative;
    flex-flow: column;
    display: flex;
    background-color: var(--neutrals-50);
    height: 100vh;
    overflow: auto;
    .body-top-wrap {
      padding: var(--spacing-medium) var(--spacing-x-large) var(--spacing-x-large) var(--spacing-x-large);
    }
    .breadcrumb-wrap {
      display: flex;
      align-items: center;
      a {
        color: var(--brand-500) !important;
        text-decoration: none;
      }
    }
  }
`;
